<template>
  <!-- Глиф инструмента "Точка": пин со знаком плюс внутри (добавить точку).
       Цвет - currentColor: серый у отжатой кнопки, зелёный у нажатой. -->
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <path d="M20 10c0 6-8 12-8 12S4 16 4 10a8 8 0 0 1 16 0Z" />
    <path d="M12 7v6M9 10h6" />
  </svg>
</template>
